import React from 'react';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';

import { Form, Button } from 'react-bootstrap';

import * as turf from '@turf/turf';
import { Formik } from 'formik';
import * as yup from 'yup';

import { useStore } from '../../../providers/AppProvider';
import { Farm, Field, Grower, Variety } from '../../../types/types';
import { CREATE_FIELD, GET_FARMS, GET_GROWERS2, UPDATE_FIELD } from '../../../../../queries';
import { GetFarms, GetGrowers, landscan_fields_insert_input } from '../../../../../__generated__/types';
import { useMutation, useQuery } from 'react-apollo';
import { CreateGrower } from './CreateGrower';
import { CreateFarm } from './CreateFarm';
import { useRouteMatch } from 'react-router-dom';

const schema = yup.object().shape({
    name: yup.string().required().max(255),
    year_planted: yup.number(),
    acres: yup.number().positive('a valid block size is required'),
    grower_id: yup.number(),
    farm_id: yup.number(),
    crop_id: yup.number(),//.required('crop is required'),
    variety_id: yup.number(),
    plant_spacing: yup.number().positive('a valid plant spacing is required'),
    row_spacing: yup.number().positive('a valid row spacing is required'),
    url: yup.string().url().max(512)
});

type FieldFormValues = {
    grower_id: string,
    farm_id: string,
    name: string,
    crop_id: string,
    variety_id: string,
    year_planted: string,
    acres: string,
    plant_spacing: string,
    row_spacing: string,
    url: string
};

const FIELD_APP_URL = process.env.REACT_APP_FIELD_MGR_ROOT_URL;

const EditFieldForm = (props: any) => {
    const match = useRouteMatch(`${FIELD_APP_URL}/:vp/fields`);
    const history = useHistory();

    const { state: { crops, varieties }, orgId } = useStore();

    const { data: growerData, refetch: refetchFarms } = useQuery<GetGrowers>(GET_GROWERS2);
    const { data: farmData, refetch: refetchGrowers } = useQuery<GetFarms>(GET_FARMS);

    useEffect(() => {
        refetchFarms();
        refetchGrowers();
    }, []);

    const [createField] = useMutation(CREATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match.url}`);
        }
    });

    const [updateField] = useMutation(UPDATE_FIELD, {
        awaitRefetchQueries: true,
        refetchQueries: [
            'GetFields' // Query name
        ],
        onCompleted: () => { 
            history.push(`${match.url}`);
        }
    });

    const [editField, setEditField] = useState<Field | null>(props.fieldToEdit);
    const [currentCropVarieties, setCurrentCropVarieties] = useState<Variety[]>([]);
    const [currrentGrowerFarms, setCurrentGrowerFarms] = useState<Farm[]>([]);
    const [growers, setGrowers] = useState<Grower[]>([]);
    const [currentGrowerId, setCurrentGrowerId] = useState<number | null>(null);
    const [farms, setFarms] = useState<Farm[]>([]);

    const [feature, setFeature] = useState<any>(null);
    const [multiFeatures, setMultiFeatures] = useState<any>(null);
    const [hasFeature, setHasFeature] = useState<boolean>(false);
    const [featureArea, setfeatureArea] = useState<number | null>(null);
    const [defaultValues, setDefaultValues] = useState<FieldFormValues>({
        grower_id: "",
        farm_id: "",
        name: "",
        crop_id: "",
        variety_id: "",
        year_planted: "",
        acres: "",
        plant_spacing: "",
        row_spacing: "",
        url: ""
    });

    const [showCreateGrower, setShowCreateGrower] = useState<boolean>(false);
    const [showCreateFarm, setShowCreateFarm] = useState<boolean>(false);


    useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
                id: g.grower_id,
                name: g.name,
                description: g.description
            } as Grower
        }) : []);
    }, [growerData]);


    useEffect(() => {
        setFarms(farmData ? farmData.landscan_farms.map(f => { 
            return {
                id: f.farm_id,
                grower_id: f.grower_id,
                name: f.name,
                description: f.description
            } as Farm
        }) : []);
    }, [farmData]);


    useEffect(() => {
        // force to update the list of the current grower
        // when the data updates.
        if(currentGrowerId) {
            setGrowersFarms(currentGrowerId);
        }
    }, [farms]);

    useEffect(() => {
        console.log("D050724 props.feature", props.feature);
        console.log("D050724 props.featureFragments", props.featureFragments);
        setFeature(props.feature && props.feature.length ? props.feature[0] : null);
        setMultiFeatures(props.featureFragments);
        //setHasFeature(props.feature && props.feature.length);
        setHasFeature(props.featureFragments && props.featureFragments.features.length);
    }, [props.feature, props.featureFragments]);

    useEffect(() => {
        //setfeatureArea(feature ? calculateAcres(feature) : null);
    }, [feature]);

    useEffect(() => {
        console.log('D050724 multiFeatures', multiFeatures);
        let acres = 0;
        multiFeatures && multiFeatures.features.forEach((f: any) => {
            console.log('D050724 f', f);
            let subacres = calculateAcres(f);
            console.log('D050724 subacres', subacres);
            acres += subacres;
            console.log('D050724 acres', acres);
        });
        setfeatureArea(acres);
    }, [multiFeatures]);


    const setCropVarieties = (cropId: number) => {
        setCurrentCropVarieties(cropId > 0 ? varieties.filter((v: Variety) => v.crop_id === cropId) : []);
    }


    const setGrowersFarms = (growerId: number) => {
        setCurrentGrowerFarms(growerId > 0 ? farms.filter((f: Farm) => f.grower_id === growerId) : [])
    }


    const years = (startYear: number) => {
        var currentYear = new Date().getFullYear(), years = [];
        startYear = startYear || 1980;
        while (startYear <= currentYear) {
            years.push(startYear++);
        }
        return years.reverse();
    }


    const calculateAcres = (geojsonFeature: any) => {
        const polygon = turf.polygon(geojsonFeature.geometry.coordinates);
        return turf.area(polygon) * 0.00024711
    }


    const onSubmit = async (data: FieldFormValues) => {
        console.log('D050724 data', data);

        // convert to a multi-polygon since the edit only returns polygons
        let geometry = null;
        if (feature && feature.geometry){
            geometry = {...feature.geometry};
            geometry.coordinates = [geometry.coordinates];      
            geometry.type = "MultiPolygon";
            geometry.crs = {
                "type": "name",
                "properties": {
                "name": "urn:ogc:def:crs:EPSG::4326"
                }
            };
        }
        let _geometry = {...multiFeatures.geometry};
        _geometry.coordinates = multiFeatures.features.map((f: any) => {
                console.log("D050724 f", f);
                return [f.geometry.coordinates[0]];
            })
        _geometry.type = "MultiPolygon";
        _geometry.crs = {
            "type": "name",
            "properties": {
              "name": "urn:ogc:def:crs:EPSG::4326"
            }
        };
        const field: landscan_fields_insert_input = {
            org_id: orgId,
            field_id: editField ? editField.id : undefined,
            name: data.name,
            grower_id: data.grower_id != "" ? parseInt(data.grower_id) : null,
            farm_id: data.farm_id != "" ? parseInt(data.farm_id) : null,
            crop_id: data.crop_id != "" ? parseInt(data.crop_id) : null,
            variety_id: data.variety_id != "" ? parseInt(data.variety_id) : null,
            acres: data.acres != "" ? parseFloat(data.acres) : featureArea?.toFixed(2),
            plant_spacing: data.plant_spacing != "" ? parseFloat(data.plant_spacing) : null,
            row_spacing: data.row_spacing != "" ? parseFloat(data.row_spacing) : null,
            year_planted: data.year_planted != "" ? parseInt(data.year_planted) : null,
            url: data.url,
            geom: JSON.stringify(_geometry)
        };
        console.log('D050724 multiFeatures', multiFeatures);
        console.log('D050724 _geometry', _geometry);
        console.log('D050724 geometry', geometry);
        console.log('D050724 field', field);
        if (editField) {
            await updateField({ variables: {id: editField.id, data: field} } );
        } else {
            await createField({ variables: {data: field} } );
        }
    }


    useEffect(() => {
        setEditField(props.fieldToEdit);

        if (props.fieldToEdit) {
            // crop is required
            setCropVarieties(props.fieldToEdit['crop_id']);

            // could be null, not required, null ok
            setCurrentGrowerId(props.fieldToEdit['grower_id']);

            // only if not null
            if(props.fieldToEdit['grower_id']) {
                setGrowersFarms(props.fieldToEdit['grower_id']);
            }

            let resetValues: FieldFormValues = {} as FieldFormValues;
            const fields = ['name', 'grower_id', 'farm_id', 'crop_id', 'acres', 'plant_spacing', 'row_spacing', 'year_planted', 'variety_id', 'url'];
            fields.forEach(f => resetValues[f as keyof FieldFormValues] = props.fieldToEdit[f] ? props.fieldToEdit[f] as string : '');
            
            setDefaultValues(resetValues);
        }
    }, [props.fieldToEdit]);


    return (
        <div className="d-flex flex-column h-100 pb-2">
            <CreateGrower isOpen={showCreateGrower} onClose={() => setShowCreateGrower(false)} />
            <CreateFarm isOpen={showCreateFarm} onClose={() => setShowCreateFarm(false)} />
            <div className="d-flex justify-content-between p-3">
                <h4>{editField ? 'Edit Block' : 'New Block'}</h4>
            </div>
            <div className="flex-grow-1 pt-0 pb-2 px-3 pt-2 overflow-auto" style={{flexBasis: 0}}>
                <Formik
                    enableReinitialize={true}
                    initialValues={defaultValues}
                    validationSchema={schema}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={async (values, { setSubmitting }) => {
                        // if we made it this far, the form validation passed.
                        // check for kinks in the polygon.
                        //const featureCol = turf.kinks(feature);
                        console.log('E050724 props.featureFragments', props.featureFragments);
                        multiFeatures.features.forEach((f: any) => {
                            console.log('E050724 f', f);
                            const featureCol = turf.kinks(f);
                            console.log('E050724 featureCol', featureCol);
                            if(featureCol.features.length > 0) {
                                alert('The block polygon is invalid. A polygon that overlaps itself is not allowed.');
                                return;
                            }
                        });
                      
                        setSubmitting(true);
                        await onSubmit(values);
                    }}
                >
                    {({
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                    }) => {
                        return (
                            <Form noValidate onSubmit={handleSubmit} autoComplete="off" className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Block</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            size="sm"
                                            placeholder="Enter block name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.name}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label className="d-flex justify-content-between">
                                            Grower
                                        </Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="grower_id"
                                                size="sm"
                                                value={values.grower_id}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.grower_id}
                                                onChange={e => {
                                                    handleChange(e);
                                                    setFieldValue('farm_id', ""); // reset farm
                                                    setCurrentGrowerId(e.currentTarget.value ? parseInt(e.currentTarget.value) : null);
                                                    setGrowersFarms(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                                }}
                                            >
                                                <option value="" label="Select a grower" disabled />
                                                {growers.map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                            <Button size="sm" className="ml-2" title="Create" onClick={() => setShowCreateGrower(true)}>
                                                +
                                            </Button>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.grower_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label className="d-flex justify-content-between">
                                            Farm
                                        </Form.Label>
                                        <div className="d-flex">
                                            <Form.Control
                                                as="select"
                                                name="farm_id"
                                                size="sm"
                                                value={values.farm_id}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={!!errors.farm_id}
                                            >
                                                <option value="" label="Select a farm" disabled />
                                                {currrentGrowerFarms.map(option => {
                                                    return <option key={option.id} value={option.id}>{option.name}</option>
                                                })}
                                            </Form.Control>
                                            <Button size="sm" className="ml-2" title="Create" onClick={() => setShowCreateFarm(true)}>
                                                +
                                            </Button>
                                        </div>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.farm_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Year Planted</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="year_planted"
                                            size="sm"
                                            value={values.year_planted}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.year_planted}
                                        >
                                            <option key={-1} value="" disabled>Select a year</option>
                                            {years(1990).map(year => {
                                                return <option key={year} value={year}>{year}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.year_planted}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Crop</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="crop_id"
                                            size="sm"
                                            value={values.crop_id}
                                            onChange={e => {
                                                handleChange(e);
                                                setFieldValue('variety_id', "");
                                                setCropVarieties(e.currentTarget.value ? parseInt(e.currentTarget.value) : -1);
                                            }}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.crop_id}
                                        >
                                            <option key={-1} value="" disabled>{'Select a crop'}</option>
                                            {crops.map(c => {
                                                return <option key={c.id} value={c.id}>{c.name}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.crop_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Variety</Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="variety_id"
                                            size="sm"
                                            value={values.variety_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.variety_id}
                                        >
                                            <option key={-1} value="" disabled>{'Select a variety'}</option>
                                            {currentCropVarieties.map(v => {
                                                return <option key={v.id} value={v.id}>{v.name}</option>
                                            })}
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.variety_id}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Acres</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="acres"
                                            size="sm"
                                            placeholder="Enter block size"
                                            value={values.acres}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.acres}
                                        />
                                        <Form.Text className="bg-info form-text px-2 text-white">
                                            Calculated size: {featureArea ? `${featureArea.toFixed(0)} acres` : 'n/a'}
                                        </Form.Text>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.acres}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Plant Spacing (feet)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="plant_spacing"
                                            size="sm"
                                            placeholder="Enter plant spacing"
                                            value={values.plant_spacing}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.plant_spacing}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.plant_spacing}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Row Spacing (feet)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="row_spacing"
                                            size="sm"
                                            placeholder="Enter row spacing"
                                            value={values.row_spacing}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.row_spacing}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.row_spacing}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Dashboard URL</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="url"
                                            size="sm"
                                            placeholder="Enter dashboard url"
                                            value={values.url}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={!!errors.url}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.url}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                                <div>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex gap-2">
                                            <Button type="submit" variant="primary" size="sm" disabled={isSubmitting || !hasFeature}>
                                                {editField ? 'Update' : 'Create'}
                                            </Button>
                                            <Button variant="secondary" size="sm" className="mx-2" onClick={() => {
                                                history.push(`${match.url}`);
                                            }}>
                                                Cancel
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
}

export default EditFieldForm;
